export const openFullScreen = (elem) => {
	if (elem.requestFullscreen) {
		elem.requestFullscreen();
	} else if (elem.webkitRequestFullscreen) {
		/* Safari */
		elem.webkitRequestFullscreen();
	} else if (elem.msRequestFullscreen) {
		/* IE11 */
		elem.msRequestFullscreen();
	}
};

export const closeFullScreen = (elem) => {
	if (elem.exitFullscreen) {
		elem.exitFullscreen();
	} else if (elem.webkitExitFullscreen) {
		/* Safari */
		elem.webkitExitFullscreen();
	} else if (elem.msExitFullscreen) {
		/* IE11 */
		elem.msExitFullscreen();
	}
};
